export function classifyFreshness(fetchedAt, now = new Date()) {
    if (fetchedAt === null)
        return "UNAVAILABLE";
    const fetched = new Date(fetchedAt);
    const ageMs = now.getTime() - fetched.getTime();
    if (!Number.isFinite(fetched.getTime()) || ageMs < 0)
        return "UNAVAILABLE";
    const ageMinutes = ageMs / 60_000;
    if (ageMinutes <= 15)
        return "RECENT";
    if (ageMinutes <= 30)
        return "DELAYED";
    return "EXPIRED";
}
//# sourceMappingURL=freshness.js.map